<template>
  <v-card>
    <v-toolbar dense>
        <v-chip icon id="pagetitle" to="/perfsum">
              <v-icon left>mdi-arrow-left</v-icon>
              {{year}}年{{month}}月考核成绩
        </v-chip>
        <v-spacer></v-spacer>
        <a ref="downloadanchor" :href="remotefilename"><p>&nbsp;</p></a>
        <v-btn color=primary @click="download">导出</v-btn>
        
    </v-toolbar>
    <department-selector v-model="tab" :departments="departmentUserObjectiveRatings" show-count show-done />
    <v-tabs-items v-model="tab">
        <v-tab-item v-for="dep in departmentUserObjectiveRatings" :key="dep.departmentid">
            <v-data-table :headers='headers' :items="dep.userObjectives" @click:row="clickRow">
                <template v-slot:item.done="{ item }">
                    <v-icon color="green" v-if="item.done">mdi-account-check</v-icon>
                    <v-icon color="yellow" v-else>mdi-account-question</v-icon>
                </template>
            </v-data-table>
        </v-tab-item>
    </v-tabs-items>
    <v-dialog  v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card  id="pagetitle">
            <v-toolbar dark color="primary">
                <v-toolbar-title>{{viewdepartmentname}}详细得分</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn icon dark @click="dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
                <objective-card v-model="viewUserObjectives" :mode="2" :highlightUserId="selectedUserId">

                </objective-card>
            </v-card-text>
        </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import ObjectiveCard from './ObjectiveCard.vue'
import DepartmentSelector from './DepartmentSelector.vue'
import { mapState } from 'vuex'
import mycfg from '@/config'
import { sortDepartmentsByName } from '@/utils/departmentsort.js'

export default {
    name: 'PrefSumPage',
    props:{
        year:{type:Number}, month:{type:Number}
    },
    components: {
        ObjectiveCard,
        DepartmentSelector
    },
    data: () => ({
        departmentUserObjectiveRatings:[],
        service: null,
        tab:0,
        dialog:false,
        headers:[
            {
                text:'姓名',
                align:'start',
                sortable:true,
                value:'username'
            },
            {
                text:'总分',
                align:'start',
                sortable:true,
                value:'totalpoints'
            },
            {
                text:'完成',
                align:'start',
                sortable:true,
                value:'done'
            }
        ],
        viewUserObjectives:[],
        selectedUserId:null,
        remotefilename:""
    }),
    computed:{
            ...mapState(['myCurManageDepartment']),
            viewdepartmentname() {
                const dep = this.departmentUserObjectiveRatings[this.tab]
                return dep ? dep.departmentname + ' ' : ''
            }
    },
    created() {
        this.service = this.$store.getters.service('user-objective-rating')

        this.loadData()
    },
    methods: {
        async loadData() {
            const {data} = await this.service.find({
                query:{
                    year:this.year,
                    month:this.month,
                    customFind:{name:'getDepartmentUserObjectivesRatings'}
                }
            })

            this.departmentUserObjectiveRatings = sortDepartmentsByName(data)
        },
        async clickRow(item) {
            const {data} = await this.service.find({
                query:{
                    year:this.year,
                    month:this.month,
                    departmentid:item.departmentid
                }
            })

            this.selectedUserId = item.userid
            this.viewUserObjectives = data
            this.dialog = true
        },
        async download() {
            const {data} = await this.service.find({
                query:{
                    year:this.year,
                    month:this.month,
                    customFind:{name:"export"}
                }
            })

            if (data == '') {
                console.log(`download error`)
                return
            }
            
            let url = `${mycfg.server_url}${data}`
            if (url.startsWith('//')) url = url.substring(1)
            this.remotefilename = url
            
            console.log(`remote file:${this.remotefilename}`)

            setTimeout(() => this.$refs.downloadanchor.click(), 50)
            // this.remotefilename = null
        }
    }
}
</script>

<style>

</style>